import type { EventName } from "@lit/react";
import { EmailField as EmailFieldElement, type EmailFieldEventMap as _EmailFieldEventMap, } from "@vaadin/email-field/vaadin-email-field.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { EmailFieldElement, };
export type EmailFieldEventMap = Readonly<{
    onValidated: EventName<_EmailFieldEventMap["validated"]>;
    onChange: EventName<_EmailFieldEventMap["change"]>;
    onInput: EventName<_EmailFieldEventMap["input"]>;
    onInvalidChanged: EventName<_EmailFieldEventMap["invalid-changed"]>;
    onValueChanged: EventName<_EmailFieldEventMap["value-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValueChanged: "value-changed" } as EmailFieldEventMap;
export type EmailFieldProps = WebComponentProps<EmailFieldElement, EmailFieldEventMap>;
export const EmailField = createComponent({
    elementClass: EmailFieldElement, events, react: React, tagName: "vaadin-email-field"
});
